<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Reporte Updated</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button class="btn-info" type="button" @click="consultar(false)">
            <i class="fa fa-search"></i>
            <span>Consultar</span>
          </button>
          <button class="btn-success" type="button" @click="exportar">
            <i class="fa fa-file-excel-o"></i>
            <span>Exportar</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-3">
            <div class="select2-field select2-field--stretch">
              <v-select id="yard" v-model="form.yard_codes" multiple @input="inputYard" :options="patios"></v-select>
              <label for="yard">Yard</label>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <div class="select2-field select2-field--stretch">
              <v-select id="status" label="name" v-model="selectedStatus" multiple :options="estados" @input="inputStatus">
              </v-select>
              <label for="status">Status</label>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <div class="select2-field select2-field--stretch">
              <v-select id="customer" label="name" v-model="selectedCustomer" multiple :options="customers"
                @input="inputCustomer"></v-select>
              <label for="customer">Customers</label>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <div class="select2-field select2-field--stretch">
              <v-select id="type" label="descripcion" v-model="selectedType" :clearable="false" :options="types" @input="inputType">
              </v-select>
              <label for="type">Type</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-md-3">
            <div class="select2-field">
              <v-select id="plantilla" label="descripcion" v-model="selectedPlantilla" :options="plantillas"
                @input="inputPlantilla"></v-select>
              <label for="plantilla">Tipo reporte</label>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <div class="form-field select">
              <div class="select-field">
                <select v-model="form.tipo_fecha" name="tipo_fecha" id="tipo_fecha">
                  <option value="T">Todas</option>
                  <option value="H">Hoy</option>
                  <option value="A">Ayer</option>
                  <option value="P">Personalizada</option>
                </select>
                <label for="tipo_fecha">Tipo de fecha</label>
              </div>
            </div>
          </div>
          <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-3">
            <div class="form-field">
              <div class="datepicker-field">
                <date-picker @enterkey="consultar" v-model="form.desde" type="date" id="desde"></date-picker>
                <label for="desde">Desde</label>
              </div>
            </div>
          </div>
          <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-3">
            <div class="form-field">
              <div class="datepicker-field">
                <date-picker @enterkey="consultar" v-model="form.hasta" type="date" id="hasta"></date-picker>
                <label for="hasta">Hasta</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <details class="card card--collapsible mt-3 mb-3">
      <summary class="card__title card__title--bg-primary">
        <div class="form-inline">
          <i class="fa fa-info-circle" aria-hidden="true"></i>
          <h5>Datos a mostrar</h5>
        </div>
      </summary>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12" style="max-height: 280px; height: auto; overflow-y: scroll">
            <checked-listbox @input="inputColumna" :items="columnas" :columns="4" name="columnas[]"
              v-model="form.columnas" field="nombre"></checked-listbox>
          </div>
        </div>
      </div>
    </details>
    <details class="card card--collapsible mt-3 mb-3" open>
      <summary class="card__title card__title--bg-primary">
        <div class="form-inline">
          <i class="fa fa-info-circle" aria-hidden="true"></i>
          <h5>Resultados</h5>
        </div>
      </summary>
      <div class="card__content" style="height: auto;">
        <dynamic-table colorTd colorTh :columnas="columns" :registros="registros" :totalItems="totalItems"
          :columnasInvisibles="form.columnasInvisibles" :columnasEditables="columnasEditables"
          :columnasCheck="columnasCheck" :columnasTexto="columnasTexto" :currentPage="form.currentPage"
          :registrosPorPagina="form.registrosPorPagina" :mostrarSelectedMultiple="true" :mostrarRegistrosTotales="true"
          :columnasBox="columnasBox" :columnasMac="columnasMac" :columnasNoResumido="columnasNoResumido"
          @seleccionado="rowSeleccionado" @handleSelected="handleSelected" ref="table"
          @handleChangePage="handleChangePage" @handleSort="handleSort" @filtrarBusqueda="filtrarBusqueda">
        </dynamic-table>
        <div v-show="registros.length !== 0" class="col-md-12 form-inline">
          <div>
            <p>Amount.B (p): {{ pag_a_b }}</p>
          </div>
          <div>
            <p>Amount.B (t): {{ total_a_b }}</p>
          </div>
          <div>
            <p>MH.B (p): {{ pag_mh_b }}</p>
          </div>
          <div>
            <p>MH.B (t): {{ total_mh_b }}</p>
          </div>
          <div>
            <p>Amount.M (p): {{ pag_a_m }}</p>
          </div>
          <div>
            <p>Amount.M (t): {{ total_a_m }}</p>
          </div>
          <div>
            <p>MH.M (p): {{ pag_mh_m }}</p>
          </div>
          <div>
            <p>MH.M (t): {{ total_mh_m }}</p>
          </div>
        </div>
      </div>
    </details>
    <modal :clickToClose="false" width="75%" height="auto" scrollable name="editarPropiedades">
      <editar-unidad :numeroContenedor="currentNumber" :historico="false" :puede_editar_status="puede_editar_status"
        :puede_eliminar="puede_eliminar" 
        :puede_editar_gate_in="puede_editar_gate_in"
        :puede_editar_gate_out="puede_editar_gate_out"
        :puede_editar_detalles="puede_editar_detalles"
        :puede_editar_in="puede_editar_in"
        :puede_editar_out="puede_editar_out"
        :puede_editar_caja="puede_editar_caja"
        :puede_editar_maquina="puede_editar_maquina"
        :puede_enviar_edi_in="puede_enviar_edi_in"
        :puede_enviar_edi_out="puede_enviar_edi_out"
        @cerrarUnidad="cerrarUnidad"
        ref="editarUnidad"
        soloEdicion
        @eliminarUnidad="eliminarUnidad" v-model="currentUnidad"></editar-unidad>
    </modal>
  </div>
</template>

<script>
import swal from "sweetalert2";

export default {
  props: {
    patios: {
      type: Array,
      required: false,
      default: () => [],
    },
    estados: {
      type: Array,
      required: false,
      default: () => [],
    },
    customers: {
      type: Array,
      required: false,
      default: () => [],
    },
    types: {
      type: Array,
      required: false,
      default: () => [],
    },
    plantillas: {
      type: Array,
      required: false,
      default: () => [],
    },
    puede_editar_status: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_eliminar: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_gate_in: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_gate_out: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_detalles: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_in: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_out: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_caja: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_maquina: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_enviar_edi_in: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_enviar_edi_out: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      patioDefault: patioDefault,
      selectedCustomer: [],
      selectedStatus: [],
      selectedType: null,
      selectedPlantilla: null,
      columnas: [],
      form: {
        tipo_fecha: "T",
        desde: moment(new Date()).subtract(7, 'd').format("YYYY-MM-DD"),
        hasta: moment(new Date()).format("YYYY-MM-DD"),
        yard_codes: ["Todos"],
        plantilla_code: "",
        status_codes: null,
        customer_codes: null,
        type_code: null,
        columnas: [{}],
        currentPage: 1,
        currentSearch: null,
        filtrosSearch: [],
        exportar: false,
        registrosPorPagina: 100,
        sort: null,
        key_sort: null,
        columnasConstantes: ['number', 'gate_in_date', 'aprobado_m', 'aprobado_b', 'repaired', 'repaired_m', 'man_hour_box', 'amount_b', 'man_hour_mac', 'amount_m'],
        columnasInvisibles: [],
        columnasDate: ['gate_in_date', 'gate_out_date', 'date_i_b', 'date_e_b', 'repaired_date', 'date_f_b', 'date_a_b', 'date_i_m', 'date_e_m', 'date_r_m', 'date_f_m', 'date_a_m', 'in_service'],
        isCampoNull: false
      },
      path: url + "/reporte/consulta/updated",

      columns: [],
      registros: [],
      totalItems: null,
      currentUnidad: null,
      currentNumber: null,
      id: 0,
      columnasEditables: [
        'amount_m',
        'amount_b',
        'man_hour_mac',
        'man_hour_box',
        'spare_parts',
        'test_on_remark'
      ],
      columnasCheck: [
        'inspection_b',
        'estimado_b',
        'repaired',
        'invoiced_box',
        'aprobado_b',
        'inspection_m',
        'estimado_m',
        'repaired_m',
        'invoiced_machine',
        'aprobado_m',
        'dispatched',
        'dispatched_out'
      ],
      columnasTexto: [
        'spare_parts',
        'test_on_remark'
      ],
      columnasBox: [
        'inspection_b', 'date_i_b', 'estimado_b', 'date_e_b', 'repaired', 'repaired_date', 'amount_b', 'invoiced_box', 
        'date_f_b', 'aprobado_b', 'date_a_b', 'man_hour_box', 'test_on_remark'
      ],
      columnasMac: [ 
        'inspection_m', 'date_i_m', 'estimado_m', 'date_e_m', 'repaired_m', 'date_r_m', 'amount_m', 'invoiced_machine', 
        'date_f_m', 'aprobado_m', 'date_a_m', 'man_hour_mac', 'spare_parts'
      ],
      columnasNoResumido: ['observacion_in'],
      statusObject: {},
      typeContainerObject: {},
      typeObject: {
        CY: 'PTO',
        CF: 'DEV',
        SD: 'CCL',
        PO: 'POS',
        AC: 'ACC'
      },
      // Totales de la consulta
      total_mh_b: 0,
      total_a_b: 0,
      total_mh_m: 0,
      total_a_m: 0,
      // Totales por página
      pag_mh_b: 0,
      pag_a_b: 0,
      pag_mh_m: 0,
      pag_a_m: 0
    };
  },
  methods: {
    handleSelected: function () {
      setTimeout(() => {
        const selection = window.getSelection();
        const txt = document.querySelector('.is-selected .number');
        const range = document.createRange();
        range.selectNodeContents(txt);
        selection.removeAllRanges();
        selection.addRange(range); 
        document.execCommand("copy");  
      }, 100);
    },
    inputCustomer: function () {
      if (this.selectedCustomer.length != 0) {
        if (this.selectedCustomer.length > 1 && this.selectedCustomer.find( customer => customer.code === 'all') ) {
          this.selectedCustomer = this.selectedCustomer.filter( customer => customer.code != 'all');
        }
        this.form.customer_codes = this.selectedCustomer.map( customer => customer.code);
      }
      else this.form.customer_codes = [];
    },
    inputStatus: function () {
      if (this.selectedStatus.length != 0) {
        if (this.selectedStatus.length > 1 && this.selectedStatus.find( status => status.code === 'all') ) {
          this.selectedStatus = this.selectedStatus.filter( status => status.code != 'all');
        }
        this.form.status_codes = this.selectedStatus.map( status => status.code);
      }
      else this.form.status_codes = [];
    },

    inputYard: function () {
      if (this.form.yard_codes.length > 1 && this.form.yard_codes.includes('Todos') ) {
        this.form.yard_codes = this.form.yard_codes.filter( yard_code => yard_code != 'Todos');
      }
    },
    inputType: function () {
      if (this.selectedType != null)
        this.form.type_code = this.selectedType.code;
      else this.form.type_code = "";
    },
    inputColumna: function (value) {
      if (value.includes('secuencia')) {
        swal(`No puede seleccionar secuencia`, 'Advertencia', 'warning');
        setTimeout(() => {
          this.form.columnas = this.form.columnas.filter(columna => columna !== 'secuencia');
        }, 100);
        return;
      }
      this.form.columnas = value;
    },
    inputPlantilla: function () {
      if (this.selectedPlantilla != null) {
        this.form.plantilla_code = this.selectedPlantilla.codigo;
        this.cargarCampos();
      }
      else {
        this.form.plantilla_code = "";
        this.columnas = [];
        this.form.columnas = [{}];
      }
    },
    exportar: function () {
      this.form.exportar = true;
      const queryString = this.serialize(this.form);
      const urlApi = this.path + queryString;
      window.open(urlApi, "_blank");
      this.form.exportar = false;
    },
    consultar: function (changePage = false) {
      const that = this;
      that.form.currentSearch = "";
      that.form.isCampoNull = false;
      this.$refs.table.limpiar();
      that.form.filtrosSearch.splice(0, that.form.filtrosSearch.length);
      if (that.form.plantilla_code != "") {
        that.columns.splice(0, that.columns.length);
        that.form.columnasInvisibles.splice(0, that.form.columnasInvisibles.length);
        if (!that.form.columnas.includes('gate_in_date'))
          that.form.columnasInvisibles.push('days');
        that.llenarColumnasInvisibles();
        if(that.form.yard_codes.length === 0)
          that.form.yard_codes.push('Todos');

        if(that.form.status_codes.length === 0) {
          that.selectedStatus.push({"code":"all","name":"Todos","descripcion":"Todos"});
          that.inputStatus();
        }
        if(that.form.customer_codes.length === 0) {
          that.selectedCustomer.push({"code":"all","name":"Todos","descripcion":"Todos"});
          that.inputCustomer();
        }
        axios
          .get(that.path, {
            params: that.form,
          })
          .then(function ({ data }) {
            // that.totalItems = data.registros.total;
            that.totalItems = parseInt(data.totales.total);
            that.total_mh_b = parseFloat(+data.totales.mh_b).toFixed(2);
            that.total_a_b = parseFloat(+data.totales.a_b).toFixed(2);
            that.total_mh_m = parseFloat(+data.totales.mh_m).toFixed(2);
            that.total_a_m = parseFloat(+data.totales.a_m).toFixed(2);
            if (!changePage) {
              that.registros.splice(0, that.registros.length);
              that.id = 1;
              that.form.currentPage = 1;
            }
            that.columns.push({
              descripcion: 'ID',
              value: 'id'
            });
            for (let i = 0; i < data.columnas.length; i++) {
              if (data.columnas[i].nombre === 'gate_in_date')
                that.columns.push({
                  descripcion: 'Days',
                  value: 'days'
                });
              that.columns.push({
                descripcion: data.columnas[i].descripcion,
                value: data.columnas[i].nombre
              });
            }
            that.llenarRegistros(data.registros);
          })
          .catch(function (error) {
            swal("Hubo un error al cargar." + error, "Error", "error");
          });
      } else {
        swal(
          "Debe seleccionar una plantilla.",
          "Aviso",
          "warning"
        );
      }
    },
    cerrarUnidad: function () {
      this.quitarShorcutUnidad();
      this.$modal.hide('editarPropiedades');
    },
    eliminarUnidad: function () {
      this.quitarShorcutUnidad();
      this.$modal.hide('editarPropiedades');
      this.consultar();
    },
    quitarShorcutUnidad: function () {
      document.removeEventListener("keydown", this.$refs.editarUnidad.pressed);
    },
    handleSearch: function (searching, search = true) {
      const that = this;
      that.form.currentSearch = searching;
      let oReq = new XMLHttpRequest();
      oReq.addEventListener("load", function () {
        if (search) {
          that.form.currentPage = 1;
          that.id = 1;
        }
        that.rellenar(that.form.currentPage);
        const parseado = JSON.parse(this.responseText);
        that.totalItems = parseInt(parseado.totales.total);
        that.total_mh_b = parseFloat(+parseado.totales.mh_b).toFixed(2);
        that.total_a_b = parseFloat(+parseado.totales.a_b).toFixed(2);
        that.total_mh_m = parseFloat(+parseado.totales.mh_m).toFixed(2);
        that.total_a_m = parseFloat(+parseado.totales.a_m).toFixed(2);
        that.llenarRegistros(parseado.registros);
        that.registros.sort((a, b) => a.id - b.id);
      });
      const queryString = that.serialize(that.form);
      let urlRequest = that.path + queryString;
      oReq.open("GET", urlRequest);
      oReq.send();
    },
    handleChangePage: function (page) {
      this.form.currentPage = page;
      const changePage = true;
      const search = false;
      this.rellenar(page);
      if ((this.form.currentSearch != null && this.form.currentSearch != "") || this.form.isCampoNull)
        this.handleSearch(this.form.currentSearch, search);
      else this.consultar(changePage);
    },
    rowSeleccionado: function (row) {
      this.currentNumber = row.number;
      this.$modal.show("editarPropiedades");
    },
    handleSort: function (sort) {
      const camposEquip= ['tara', 'gross', 'model', 'in_service'];
      const that = this;
      if (sort[0] === 'id' || camposEquip.includes(sort[0]))
        return;
      that.form.key_sort = sort[0];
      that.form.sort = sort[1];
      let oReq = new XMLHttpRequest();
      oReq.addEventListener("load", function () {
        that.form.currentPage = 1;
        that.id = 1;
        that.rellenar(that.form.currentPage);
        const parseado = JSON.parse(this.responseText);
        that.totalItems = parseInt(parseado.totales.total);
        that.total_mh_b = parseFloat(+parseado.totales.mh_b).toFixed(2);
        that.total_a_b = parseFloat(+parseado.totales.a_b).toFixed(2);
        that.total_mh_m = parseFloat(+parseado.totales.mh_m).toFixed(2);
        that.total_a_m = parseFloat(+parseado.totales.a_m).toFixed(2);
        that.llenarRegistros(parseado.registros);
        that.registros.sort((a, b) => a.id - b.id);
      });
      const queryString = that.serialize(that.form);
      let urlRequest = that.path + queryString;
      oReq.open("GET", urlRequest);
      oReq.send();
    },
    filtrarBusqueda: function (filtros) {
      this.form.filtrosSearch.splice(0, this.form.filtrosSearch.length)
      if (!filtros.todosSelectedMultiple)
        for (let i = 0; i < filtros.selectedMultiple.length; i++) {
          this.form.filtrosSearch.push(filtros.selectedMultiple[i].value);
        }
      this.form.isCampoNull = filtros.camposNull;
    },
    rellenar: function (page) {
      this.registros.splice(0, this.registros.length);
      this.id = 1;
      if (page != 1) {
        const relleno = (page * this.form.registrosPorPagina) - this.form.registrosPorPagina;
        for (let i = 0; i < relleno; i++) {
          const aux = [{}];
          this.id++;
          this.registros.push(aux);
        }
      }
    },
    selectDefault: function () {
      this.selectedCustomer.push(this.customers[0]);
      this.selectedStatus.push(this.estados[0]);
      this.selectedType = this.types[0];
      this.inputCustomer();
      this.inputStatus();
      this.inputType();
    },
    formatearCampo: function (clave) {
      return this.columnasEditables
        .filter(columna => !this.columnasTexto.includes(columna))
        .includes(clave);
    },
    llenarRegistros: function (data) {
      const that = this;
      that.pag_a_b = 0;
      that.pag_mh_b = 0;
      that.pag_a_m = 0;
      that.pag_mh_m = 0;
      for (let i = 0; i < data.length; i++) {
        const object = {};
        that.pag_a_b = ((+that.pag_a_b) + (+data[i].amount_b)).toFixed(2);
        that.pag_mh_b = ((+that.pag_mh_b) + (+data[i].man_hour_box)).toFixed(2);
        that.pag_a_m = ((+that.pag_a_m) + (+data[i].amount_m)).toFixed(2);
        that.pag_mh_m = ((+that.pag_mh_m) + (+data[i].man_hour_mac)).toFixed(2);
        for (let j = 0; j < that.columns.length; j++) {
          if (that.columns[j].value == "id") {
            object[that.columns[j].value] = that.id;
            continue;
          }
          if (that.columns[j].value == "days") {
            const fechaActual = moment(0, "HH");
            let gate_in = moment(new Date(data[i]['gate_in_date'])).format('YYYY-MM-DD');
            gate_in = moment(new Date(gate_in + ' 00:00:00'));
            object[that.columns[j].value] = fechaActual.diff(gate_in, 'days');
            continue;
          }
          if (that.formatearCampo(that.columns[j].value)) {
            const number = data[i][that.columns[j].value];
            object[that.columns[j].value] = number === null ? null : parseFloat(number).toFixed(2);
            continue;
          }
          if (that.esFecha(that.columns[j].value)) {
            object[that.columns[j].value] = that.parseDate(that.columns[j].value, data[i][that.columns[j].value]);
            continue;
          }
          if (that.columns[j].value == "cy_sd_in") {
            object[that.columns[j].value] = that.getTypeValue(data[i][that.columns[j].value]);
            continue;
          }
          object[that.columns[j].value] = data[i][that.columns[j].value];
        }
        that.registros.push(object);
        that.id++;
      }
    },
    llenarColumnasInvisibles: function () {
      this.form.columnasConstantes.map(columna => {
        if (!this.form.columnas.includes(columna))
          this.form.columnasInvisibles.push(columna);
      });
    },
    esFecha: function (campo) {
      return this.form.columnasDate.includes(campo);
    },
    parseDate: function (campo, value) {
      const fechaHora = ['gate_in_date', 'gate_out_date', 'in_service'];
      let format = "";
      if (value == null || value === '')
        return '';
      if (fechaHora.includes(campo))
        format = "YYYY-MM-DD HH:mm";
      else {
        format = "YYYY-MM-DD";
        value = moment(new Date(value)).format(format) + ' 00:00:00';
      }
      return moment(new Date(value)).format(format);
    },
    typeContainerValue: function (type) {
      return this.typeContainerObject[type] || '';
    },
    statusValue: function (status) {
      return this.statusObject[status] || '';
    },
    getTypeValue: function (key) {
      return this.typeObject[key] || '';
    },
    serialize: function (obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function (a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
    cargarCampos: function () {
      const that = this;
      axios
        .get(url + "/reporte/campos/" + that.form.plantilla_code)
        .then(function ({ data }) {
          that.columnas = data.todos_campos;
          that.form.columnas = data.campos_default.filter(campo => campo !== 'secuencia');
        })
        .catch(function () {
          swal("Hubo un error al cargar.", "Error", "error");
        });
    },
    pressed: function (e) {
      if (e.altKey && e.code === "Enter"){
        e.preventDefault();
        this.consultar();
      }
      if (e.altKey && e.code === "KeyE"){
        e.preventDefault();
        this.exportar();
      }
    }
  },
  computed: {
  },
  mounted: function () {
    if (this.patioDefault != '' && this.patioDefault != null) {
      this.form.yard_codes.splice(0, this.form.yard_codes.length);
      for (let i = 0; i < this.patios.length; i++) {
        if (this.patioDefault == this.patios[i]) {
          this.form.yard_codes.push(this.patios[i]);
          this.inputYard();
        }
      }
    }
    this.selectDefault();
    const inputSearch = document.querySelector("input.input-search");
    inputSearch.addEventListener("keyup", (e) => {
      if (e.keyCode === 13) {
        this.handleSearch(inputSearch.value);
      }
    });
    if (this.plantillas.length != 0) {
      this.selectedPlantilla = this.plantillas[0];
      this.form.plantilla_code = this.selectedPlantilla.codigo;
      this.cargarCampos();
    }
    this.estados
      .filter(estado => estado.code != 'all')
      .map(estado => this.statusObject[estado.code] = estado.name);

    this.types
      .filter(type => type.code != 'all')
      .map(type => this.typeContainerObject[type.code] = type.descripcion);
    document.addEventListener("keydown", this.pressed);
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/reportes/ReporteUpdated.vue